import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
import { IConsentResult } from "@shared/interfaces/consent.interface";

@Injectable({
  providedIn: "root",
})
export class ConsentService {
  constructor(private api: ApiService) {}

  /**
   * Fetch latest consent form by language
   * @param lang language code (required)
   */
  public getLatestConsent(lang: string): Observable<IConsentResult> {
    return this.api.get("latest-consent", { lang: lang }) as Observable<IConsentResult>;
  }
}
